import { GALLERY as GALLERY_FALLBACK } from "@/data";
import { Reveal, Overline } from "@/components/Reveal";
import { useCollection } from "@/hooks/useCollection";

export const Gallery = () => {
  const { data: GALLERY } = useCollection("gallery", "/gallery", GALLERY_FALLBACK);
  return (
    <section id="galeri" className="bg-ink py-24 md:py-36 px-6 md:px-10">
      <div className="mx-auto max-w-7xl">
        <div className="max-w-2xl mb-14">
          <Reveal>
            <Overline dark>Dokumentasi Proses Produksi</Overline>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-cream">
              Setiap langkah, kami dokumentasikan dengan jujur.
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 auto-rows-[220px] md:auto-rows-[260px] gap-4">
          {GALLERY.map((g, i) => (
            <Reveal
              key={i}
              delay={i * 0.06}
              className={`col-span-1 ${g.span} overflow-hidden rounded-2xl group`}
            >
              <img
                data-testid={`gallery-img-${i}`}
                src={g.url}
                alt={g.alt}
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
              />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
